(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["holder-usage-steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    document.querySelectorAll('[data-holder-usage-story]').forEach((section) => {
      if (section.dataset.usageReady === 'true') return;
      section.dataset.usageReady = 'true';

      const scenes = [...section.querySelectorAll('[data-usage-scene]')];
      const mobileTabs = [...section.querySelectorAll('[data-usage-tab]')];
      const mobileDetails = [...section.querySelectorAll('[data-usage-detail]')];
      const usageToggle = section.querySelector('[data-usage-toggle]');
      const usageTrigger = section.querySelector('[data-usage-trigger]');
      const previousButton = section.querySelector('[data-usage-previous]');
      const nextButton = section.querySelector('[data-usage-next]');
      const currentStepLabel = section.querySelector('[data-usage-current]');
      const video = section.querySelector('[data-usage-primary-video]') || section.querySelector('video');
      const reverseVideo = section.querySelector('[data-usage-reverse-video]');
      const segmentVideos = [video, reverseVideo].filter(Boolean);
      const visual = section.querySelector('.holder-usage-story__visual');
      const progressBar = section.querySelector('[data-usage-progress]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = window.matchMedia('(max-width: 749px)');
      const isCoreStory = section.classList.contains('holder-usage-story--core');
      const isJuStory = section.classList.contains('holder-usage-story--ju');
      const sceneRanges = [
        [0, 0],
        [0.18, 0.37],
        [0.37, 0.59],
        [0.59, 0.73],
        [0.73, 0.98]
      ];
      let activeScene = 0;
      let frameRequest = 0;
      let progress = 0;
      let pendingTime = null;
      let hasDecodedFrame = false;
      let canRevealVideo = false;
      let mobileStopTime = null;
      let mobilePlayToken = 0;
      let pendingMobileStep = null;
      let pendingMobileShouldPlay = false;
      let activeSegmentVideo = video;

      if (isJuStory && video) {
        const fallbackDuration = 18.37;
        const fadeOutDuration = 260;
        const fadeInDuration = 430;
        let juStep = 0;
        let juAnimationFrame = 0;
        let juPlayToken = 0;
        let juDuration = fallbackDuration;
        let juScrollArmed = false;
        let juScrollBaseline = window.scrollY;

        const wait = (duration) => new Promise((resolve) => window.setTimeout(resolve, duration));
        const lerp = (from, to, amount) => from + ((to - from) * amount);
        const segments = {
          1: { start: 3.50, end: 8.57, direction: 1, transformStart: 3.50, transformEnd: 8.57, zoomStart: 1, zoomEnd: 1, panStart: 0, panEnd: 0 },
          2: { start: 8.57, end: 11.28, direction: 1, transformStart: 8.57, transformEnd: 10.23, zoomStart: 1, zoomEnd: 1.78, panStart: 0, panEnd: 0 },
          3: { start: 11.28, end: fallbackDuration, direction: 1, transformStart: 13.30, transformEnd: fallbackDuration, zoomStart: 1.78, zoomEnd: 1, panStart: 0, panMid: 60, panEnd: 40 },
          4: { start: 0, end: 3.50, direction: 1, transformStart: 0, transformEnd: 3.50, zoomStart: 1, zoomEnd: 1, panStart: 0, panEnd: 0 }
        };

        const cancelJuPlayback = () => {
          juPlayToken += 1;
          window.cancelAnimationFrame(juAnimationFrame);
          juAnimationFrame = 0;
          video.pause();
        };

        const setJuTransform = (segment, amount) => {
          const playbackAmount = clamp(amount, 0, 1);
          const videoTime = lerp(segment.start, segment.end, playbackAmount);
          const transformSpan = Math.max(.01, segment.transformEnd - segment.transformStart);
          const progressAmount = clamp((videoTime - segment.transformStart) / transformSpan, 0, 1);
          visual?.style.setProperty('--usage-zoom', lerp(segment.zoomStart, segment.zoomEnd, progressAmount).toFixed(4));
          const panAmount = Number.isFinite(segment.panMid)
            ? (progressAmount <= .5
              ? lerp(segment.panStart, segment.panMid, progressAmount * 2)
              : lerp(segment.panMid, segment.panEnd, (progressAmount - .5) * 2))
            : lerp(segment.panStart, segment.panEnd, progressAmount);
          visual?.style.setProperty('--usage-pan-y', `${panAmount.toFixed(3)}%`);
        };

        const seekJuVideo = (time, token) => new Promise((resolve) => {
          if (token !== juPlayToken) {
            resolve(false);
            return;
          }
          const target = clamp(time, 0, Math.max(0, juDuration - 0.02));
          if (video.readyState >= 2 && Math.abs(video.currentTime - target) < 0.035) {
            resolve(true);
            return;
          }
          let settled = false;
          const finish = () => {
            if (settled) return;
            settled = true;
            video.removeEventListener('seeked', finish);
            resolve(token === juPlayToken);
          };
          video.addEventListener('seeked', finish, { once: true });
          try {
            video.currentTime = target;
          } catch (error) {
            finish();
          }
          window.setTimeout(finish, 420);
        });

        const updateJuPanels = (step) => {
          juStep = clamp(step, 0, 4);
          section.classList.toggle('is-ju-initial', juStep === 0);
          section.classList.toggle('has-active-step', juStep > 0);
          scenes.forEach((scene) => {
            const isActive = juStep > 0 && Number(scene.dataset.usageScene) === juStep;
            scene.classList.toggle('is-active', isActive);
            scene.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
          mobileDetails.forEach((detail) => {
            const isActive = juStep > 0 && Number(detail.dataset.usageDetail) === juStep;
            detail.classList.toggle('is-active', isActive);
            detail.hidden = !isActive;
          });
          if (currentStepLabel) currentStepLabel.textContent = `${String(juStep).padStart(2, '0')} / 04`;
          if (previousButton) previousButton.disabled = juStep === 0;
          if (nextButton) nextButton.disabled = juStep === 4;
        };

        const playJuSegment = async (step) => {
          const segment = { ...segments[step] };
          if (!segment) return;
          const playbackEnd = segment.direction > 0
            ? Math.max(segment.start, Math.min(segment.end, juDuration - 0.02))
            : Math.max(0, segment.end);
          cancelJuPlayback();
          const token = juPlayToken;
          section.classList.add('is-ju-fading');
          setJuTransform(segment, 0);
          const didSeek = await seekJuVideo(segment.start, token);
          if (!didSeek || token !== juPlayToken) return;
          await wait(fadeOutDuration);
          if (token !== juPlayToken) return;
          visual?.classList.add('is-frame-ready');
          section.classList.remove('is-ju-fading');
          await wait(fadeInDuration);
          if (token !== juPlayToken) return;

          const span = Math.max(0.01, Math.abs(playbackEnd - segment.start));
          if (reduceMotion.matches) {
            await seekJuVideo(playbackEnd, token);
            setJuTransform(segment, 1);
            return;
          }

          if (segment.direction > 0) {
            try {
              await video.play();
            } catch (error) {
              // The decoded first frame remains visible if the browser blocks playback.
            }
            const monitorForward = () => {
              if (token !== juPlayToken) return;
              const amount = clamp((video.currentTime - segment.start) / span, 0, 1);
              setJuTransform(segment, amount);
              if (video.currentTime >= playbackEnd - 0.035) {
                video.pause();
                video.currentTime = playbackEnd;
                setJuTransform(segment, 1);
                return;
              }
              juAnimationFrame = window.requestAnimationFrame(monitorForward);
            };
            juAnimationFrame = window.requestAnimationFrame(monitorForward);
            return;
          }

          const startedAt = performance.now();
          const monitorReverse = (now) => {
            if (token !== juPlayToken) return;
            const elapsed = (now - startedAt) / 1000;
            const amount = clamp(elapsed / span, 0, 1);
            video.currentTime = lerp(segment.start, playbackEnd, amount);
            setJuTransform(segment, amount);
            if (amount >= 1) {
              video.pause();
              return;
            }
            juAnimationFrame = window.requestAnimationFrame(monitorReverse);
          };
          juAnimationFrame = window.requestAnimationFrame(monitorReverse);
        };

        const selectJuStep = (step) => {
          const nextStep = clamp(step, 0, 4);
          updateJuPanels(nextStep);
          if (nextStep === 0) {
            cancelJuPlayback();
            section.classList.add('is-ju-monochrome');
            juScrollArmed = false;
            section.classList.add('is-ju-fading');
            setJuTransform(segments[1], 0);
            seekJuVideo(0, juPlayToken).finally(() => {
              if (juStep !== 0) return;
              visual?.classList.add('is-frame-ready');
              section.classList.remove('is-ju-fading');
            });
            return;
          }
          section.classList.remove('is-ju-monochrome');
          playJuSegment(nextStep);
        };

        segmentVideos.forEach((segmentVideo) => {
          segmentVideo.muted = true;
          segmentVideo.defaultMuted = true;
          segmentVideo.playsInline = true;
          segmentVideo.loop = false;
          segmentVideo.preload = 'auto';
          segmentVideo.pause();
        });
        reverseVideo?.classList.remove('is-active-media');
        video.classList.add('is-active-media');
        section.classList.add('is-expanded', 'is-mobile-viewer', 'is-ju-initial', 'is-ju-monochrome');
        visual?.classList.add('is-frame-ready');
        updateJuPanels(0);

        video.addEventListener('loadedmetadata', () => {
          if (Number.isFinite(video.duration) && video.duration > 0) juDuration = video.duration;
          if (juStep === 0) video.currentTime = 0;
        });
        nextButton?.addEventListener('click', () => selectJuStep(juStep + 1));
        previousButton?.addEventListener('click', () => selectJuStep(juStep - 1));

        const revealJuColorOnScroll = () => {
          if (!juScrollArmed || juStep !== 0) return;
          const rect = section.getBoundingClientRect();
          if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
          if (Math.abs(window.scrollY - juScrollBaseline) < 4) return;
          section.classList.remove('is-ju-monochrome');
          juScrollArmed = false;
          window.removeEventListener('scroll', revealJuColorOnScroll);
        };
        const juEntryObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting || juStep !== 0 || !section.classList.contains('is-ju-monochrome')) return;
            juScrollBaseline = window.scrollY;
            juScrollArmed = true;
          });
        }, { threshold: 0.08 });
        juEntryObserver.observe(section);
        window.addEventListener('scroll', revealJuColorOnScroll, { passive: true });
        video.load();
        return;
      }

      const isMobileViewer = () => (isCoreStory && mobileViewport.matches) || isJuStory;

      const setScene = (nextScene) => {
        if (nextScene === activeScene) return;
        activeScene = nextScene;
        scenes.forEach((scene, index) => {
          const isActive = index === activeScene;
          scene.classList.toggle('is-active', isActive);
          scene.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      const render = () => {
        frameRequest = 0;
        if (isMobileViewer()) return;
        const rect = section.getBoundingClientRect();
        const distance = Math.max(1, section.offsetHeight - window.innerHeight);
        progress = clamp(-rect.top / distance, 0, 1);
        const nextScene = Math.min(4, Math.floor(progress * 5));
        const sceneProgress = clamp((progress - (nextScene * 0.2)) / 0.2, 0, 1);
        canRevealVideo = nextScene > 0;
        if (!canRevealVideo && visual) {
          hasDecodedFrame = false;
          visual.classList.remove('is-frame-ready');
        }
        setScene(nextScene);

        if (progressBar) {
          progressBar.style.transform = `scaleX(${progress})`;
        }

        if (video && Number.isFinite(video.duration) && video.duration > 0) {
          const sceneRange = sceneRanges[nextScene];
          const timeFraction = sceneRange[0] + ((sceneRange[1] - sceneRange[0]) * sceneProgress);
          const targetTime = timeFraction * Math.max(0, video.duration - 0.04);
          requestVideoTime(targetTime);
        }
      };

      const revealDecodedFrame = () => {
        if (!canRevealVideo || hasDecodedFrame || !visual) return;
        let revealed = false;
        const reveal = () => {
          if (revealed || !canRevealVideo) return;
          revealed = true;
          hasDecodedFrame = true;
          visual.classList.add('is-frame-ready');
        };
        if (video && 'requestVideoFrameCallback' in video) {
          video.requestVideoFrameCallback(reveal);
        }
        window.requestAnimationFrame(() => window.setTimeout(reveal, 80));
      };

      const requestVideoTime = (targetTime) => {
        if (!video || video.readyState < 2 || !Number.isFinite(video.duration)) return;
        pendingTime = clamp(targetTime, 0, Math.max(0, video.duration - 0.04));
        if (video.seeking || Math.abs(video.currentTime - pendingTime) <= 0.055) {
          if (!video.seeking) revealDecodedFrame();
          return;
        }
        const nextTime = pendingTime;
        pendingTime = null;
        video.currentTime = nextTime;
      };

      const continuePendingSeek = () => {
        revealDecodedFrame();
        if (pendingTime === null || Math.abs(video.currentTime - pendingTime) <= 0.055) return;
        const nextTime = pendingTime;
        pendingTime = null;
        window.requestAnimationFrame(() => requestVideoTime(nextTime));
      };

      const requestRender = () => {
        if (frameRequest || reduceMotion.matches || isMobileViewer()) return;
        frameRequest = window.requestAnimationFrame(render);
      };

      const revealMobileFrame = (token) => {
        if (token !== mobilePlayToken) return;
        const reveal = () => {
          if (token !== mobilePlayToken) return;
          if (!activeSegmentVideo || activeSegmentVideo.readyState < 2) {
            activeSegmentVideo?.addEventListener('loadeddata', () => revealMobileFrame(token), { once: true });
            return;
          }
          visual?.classList.add('is-frame-ready');
          section.classList.add('is-mobile-ready');
          section.classList.remove('is-mobile-switching');
        };
        if (activeSegmentVideo && 'requestVideoFrameCallback' in activeSegmentVideo) {
          activeSegmentVideo.requestVideoFrameCallback(reveal);
        }
        window.requestAnimationFrame(() => window.setTimeout(reveal, 90));
      };

      const updateMobilePanels = (step) => {
        mobileTabs.forEach((tab) => {
          const isActive = Number(tab.dataset.usageTab) === step;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          if (isActive) {
            tab.setAttribute('aria-current', 'step');
          } else {
            tab.removeAttribute('aria-current');
          }
        });
        mobileDetails.forEach((detail) => {
          const isActive = Number(detail.dataset.usageDetail) === step;
          detail.classList.toggle('is-active', isActive);
          detail.hidden = !isActive;
        });
        if (currentStepLabel && step > 0) {
          currentStepLabel.textContent = `0${step} / 04`;
        }
        if (previousButton) previousButton.disabled = step <= 1;
        if (nextButton) nextButton.disabled = step >= 4;
      };

      const activateMobileStep = (step, shouldPlay) => {
        if (!isMobileViewer()) return;
        const safeStep = clamp(step, 1, 4);
        const token = ++mobilePlayToken;
        const playbackVideo = video;
        activeSegmentVideo = playbackVideo;
        section.classList.add('is-expanded', 'has-active-step');
        if (usageToggle) {
          usageToggle.setAttribute('aria-expanded', 'true');
          usageToggle.setAttribute('aria-label', usageToggle.dataset.closeLabel || 'Close');
        }
        updateMobilePanels(safeStep);
        setScene(safeStep);
        section.classList.add('is-mobile-switching');
        visual?.classList.remove('is-frame-ready');
        section.classList.remove('is-mobile-ready');
        mobileStopTime = null;
        segmentVideos.forEach((item) => {
          item.pause();
          item.classList.toggle('is-active-media', item === playbackVideo);
        });

        if (!playbackVideo || !Number.isFinite(playbackVideo.duration) || playbackVideo.duration <= 0) {
          pendingMobileStep = safeStep;
          pendingMobileShouldPlay = shouldPlay;
          if (playbackVideo && playbackVideo.readyState < 1) playbackVideo.load();
          if (playbackVideo) {
            playbackVideo.addEventListener('loadedmetadata', () => {
              if (token === mobilePlayToken) activateMobileStep(safeStep, shouldPlay);
            }, { once: true });
          }
          window.setTimeout(() => revealMobileFrame(token), 120);
          return;
        }

        pendingMobileStep = null;
        pendingMobileShouldPlay = false;
        const duration = Math.max(0, playbackVideo.duration - 0.04);
        let startTime;
        let endTime;
        if (isJuStory) {
          const juRanges = {
            1: [3, 9],
            2: [9, 11],
            3: [11, 18],
            4: [0, 3]
          };
          const range = juRanges[safeStep];
          startTime = clamp(range[0], 0, duration);
          endTime = clamp(range[1], 0, duration);
        } else {
          const range = sceneRanges[safeStep];
          startTime = range[0] * duration;
          endTime = range[1] * duration;
        }

        const beginSegment = () => {
          if (token !== mobilePlayToken) return;
          revealMobileFrame(token);
          if (!shouldPlay || reduceMotion.matches) return;
          mobileStopTime = endTime;
          const playAttempt = playbackVideo.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {
              mobileStopTime = null;
            });
          }
        };

        if (Math.abs(playbackVideo.currentTime - startTime) <= 0.045) {
          beginSegment();
          return;
        }
        playbackVideo.addEventListener('seeked', beginSegment, { once: true });
        playbackVideo.currentTime = startTime;
      };

      const stopMobileSegment = () => {
        if (!isMobileViewer() || mobileStopTime === null || !activeSegmentVideo) return;
        if (activeSegmentVideo.currentTime < mobileStopTime - 0.025) return;
        activeSegmentVideo.pause();
        activeSegmentVideo.currentTime = mobileStopTime;
        mobileStopTime = null;
      };

      const applyViewportMode = () => {
        section.classList.toggle('is-mobile-viewer', isMobileViewer());
        if (!isMobileViewer()) {
          section.classList.remove('is-mobile-ready', 'is-mobile-switching');
          mobileStopTime = null;
          segmentVideos.forEach((item) => item.pause());
          requestRender();
          return;
        }
        if (frameRequest) {
          window.cancelAnimationFrame(frameRequest);
          frameRequest = 0;
        }
        segmentVideos.forEach((item) => {
          item.pause();
          item.muted = true;
          item.defaultMuted = true;
        });
        if (isJuStory && !section.classList.contains('has-active-step')) {
          updateMobilePanels(0);
          setScene(0);
          visual?.classList.remove('is-frame-ready');
          section.classList.remove('is-mobile-ready', 'is-mobile-switching');
          return;
        }
        updateMobilePanels(activeScene || 1);
        section.classList.add('is-mobile-switching');
        window.setTimeout(() => activateMobileStep(activeScene || 1, false), 140);
      };

      const applyMotionPreference = () => {
        section.classList.toggle('is-reduced', reduceMotion.matches && !isMobileViewer());
        if (reduceMotion.matches && !isMobileViewer()) {
          scenes.forEach((scene) => scene.setAttribute('aria-hidden', 'false'));
          if (video) video.currentTime = 0;
          return;
        }
        scenes.forEach((scene, index) => scene.setAttribute('aria-hidden', index === activeScene ? 'false' : 'true'));
        if (isMobileViewer()) {
          if (isJuStory && !section.classList.contains('has-active-step')) {
            updateMobilePanels(0);
          } else {
            activateMobileStep(activeScene || 1, false);
          }
        } else {
          requestRender();
        }
      };

      let juCascadeTimer = 0;

      const setJuExpanded = (expanded) => {
        if (!isJuStory || !usageToggle) return;
        const wasExpanded = section.classList.contains('is-expanded');
        window.clearTimeout(juCascadeTimer);
        section.classList.remove('is-cascade-opening');

        if (expanded && !reduceMotion.matches) {
          void section.offsetHeight;
          section.classList.add('is-cascade-opening');
          juCascadeTimer = window.setTimeout(() => {
            section.classList.remove('is-cascade-opening');
          }, 1100);
        }

        section.classList.toggle('is-expanded', expanded);
        usageToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        usageToggle.setAttribute('aria-label', expanded
          ? (usageToggle.dataset.closeLabel || 'Close')
          : (usageToggle.dataset.openLabel || 'Open'));
        if (expanded) {
          if (wasExpanded) return;
          activateMobileStep(1, true);
          return;
        }

        ++mobilePlayToken;
        mobileStopTime = null;
        segmentVideos.forEach((item) => item.pause());
        section.classList.remove('has-active-step', 'is-mobile-ready', 'is-mobile-switching');
        visual?.classList.remove('is-frame-ready');
        updateMobilePanels(0);
        setScene(0);
      };

      if (video) {
        let videoRetryCount = 0;
        const keepPosterVisible = () => visual?.classList.remove('is-frame-ready');
        const warmVideo = () => {
          video.preload = 'auto';
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('muted', '');
          video.setAttribute('playsinline', '');
          if (video.readyState < 2) video.load();

          const warmPlayback = video.play();
          if (warmPlayback && typeof warmPlayback.then === 'function') {
            warmPlayback
              .then(() => {
                video.pause();
                requestRender();
              })
              .catch(requestRender);
          }
        };

        video.pause();
        video.addEventListener('loadedmetadata', () => {
          if (isMobileViewer() && pendingMobileStep !== null) {
            activateMobileStep(pendingMobileStep, pendingMobileShouldPlay);
          } else {
            requestRender();
          }
        }, { once: true });
        video.addEventListener('loadeddata', requestRender, { once: true });
        video.addEventListener('canplay', requestRender, { once: true });
        video.addEventListener('seeked', continuePendingSeek);
        segmentVideos.forEach((item) => item.addEventListener('timeupdate', stopMobileSegment));
        video.addEventListener('error', () => {
          keepPosterVisible();
          if (videoRetryCount > 0) return;
          videoRetryCount += 1;
          window.setTimeout(warmVideo, 800);
        });
        if ('IntersectionObserver' in window) {
          const preloadObserver = new IntersectionObserver((entries, observer) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            warmVideo();
            observer.disconnect();
          }, { rootMargin: '200% 0px' });
          preloadObserver.observe(section);
        } else {
          warmVideo();
        }

        if (reverseVideo) {
          reverseVideo.muted = true;
          reverseVideo.defaultMuted = true;
          reverseVideo.playsInline = true;
          reverseVideo.setAttribute('muted', '');
          reverseVideo.setAttribute('playsinline', '');
          reverseVideo.load();
        }
      }

      usageTrigger?.addEventListener('click', () => {
        setJuExpanded(!section.classList.contains('is-expanded'));
      });

      previousButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        if (activeScene <= 1) return;
        activateMobileStep(activeScene - 1, true);
      });

      nextButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        if (activeScene >= 4) return;
        activateMobileStep(activeScene + 1, true);
      });

      mobileTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          setJuExpanded(true);
          activateMobileStep(Number(tab.dataset.usageTab), true);
        });
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const currentIndex = mobileTabs.indexOf(tab);
          let nextIndex = currentIndex;
          if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);
          if (event.key === 'ArrowDown') nextIndex = Math.min(mobileTabs.length - 1, currentIndex + 1);
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = mobileTabs.length - 1;
          mobileTabs[nextIndex]?.focus();
          activateMobileStep(Number(mobileTabs[nextIndex]?.dataset.usageTab), true);
        });
      });

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', applyViewportMode, { passive: true });
      mobileViewport.addEventListener('change', applyViewportMode);
      reduceMotion.addEventListener('change', applyMotionPreference);
      applyViewportMode();
      applyMotionPreference();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-story-accordion"] && !Shopify.designMode) return;
  try {
    
  const initializeHomeStoryAccordions = (root = document) => {
    root.querySelectorAll('.home-story-accordion').forEach((section) => {
      if (section.dataset.accordionReady === 'true') return;

      const items = Array.from(section.querySelectorAll('.home-story-accordion__item'));
      const parentToggle = section.querySelector('[data-story-parent-toggle]');
      const parentTrigger = section.querySelector('[data-story-parent-trigger]');
      const collectionHeaderLink = section.querySelector('.home-story-accordion__header-link');
      const visualVideo = section.querySelector('[data-story-visual-video]');
      const visualFrame = section.querySelector('[data-story-visual-frame]');
      const aiOpenButtons = Array.from(section.querySelectorAll('[data-story-ai-open]'));
      const aiModal = section.querySelector('[data-story-ai-modal]');
      const aiDismissButtons = aiModal ? Array.from(aiModal.querySelectorAll('[data-story-ai-dismiss]')) : [];
      const aiPlatformLinks = aiModal ? Array.from(aiModal.querySelectorAll('[data-story-ai-platform]')) : [];
      const aiStatus = aiModal ? aiModal.querySelector('[data-story-ai-status]') : null;
      const aiCleanupCallbacks = [];

      const markCollectionScrollReset = () => {
        if (!collectionHeaderLink) return;
        try {
          const destination = new URL(collectionHeaderLink.href, window.location.href);
          if (destination.origin !== window.location.origin || !destination.pathname.includes('/collections/')) return;
          window.sessionStorage.setItem('acosmeticstory:collection-scroll-reset', destination.pathname);
        } catch (error) {}
      };

      if (collectionHeaderLink) collectionHeaderLink.addEventListener('click', markCollectionScrollReset);

      const compatibilityGroups = Array.from(section.querySelectorAll('[data-holder-compatibility]'));
      compatibilityGroups.forEach((group) => {
        const tabs = Array.from(group.querySelectorAll('[data-holder-compatibility-tab]'));
        // 이 항목의 영상은 섹션 대표 영상 자리에서 재생된다. 탭을 고르면 그 항목의
        // data-story-item-visual 을 바꾸고, 대표 영상 쪽 갱신 루틴을 그대로 태운다.
        const owner = group.closest('.home-story-accordion__item');
        if (!tabs.length || !owner) return;

        const activateTab = (tab, shouldFocus = false) => {
          tabs.forEach((item) => {
            const selected = item === tab;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });

          const nextUrl = tab.dataset.videoUrl;
          if (nextUrl && owner.dataset.storyItemVisual !== nextUrl) {
            owner.dataset.storyItemVisual = nextUrl;
            applyItemVisual();
            updateVisualSource();
          }

          if (shouldFocus) tab.focus();
        };

        // 항목을 펼치는 순간에도 선택된 탭의 영상으로 맞춘다. 항목 개폐를 담당하는
        // updateOpenState 는 애니메이션이 끝난 뒤에야 도는 구간이 있어, 그 사이 대표
        // 영상이 잠깐 보이는 것을 막는다.
        const handleOwnerToggle = () => {
          if (!owner.open) return;
          const active = tabs.find((item) => item.classList.contains('is-active')) || tabs[0];
          if (active && active.dataset.videoUrl) owner.dataset.storyItemVisual = active.dataset.videoUrl;
          // activateTab 을 거치지 않고 직접 부른다. 열기 직전 값이 이미 같으면
          // activateTab 은 아무것도 하지 않아서 대표 영상이 그대로 남는다.
          applyItemVisual();
          updateVisualSource();
        };
        owner.addEventListener('toggle', handleOwnerToggle);
        aiCleanupCallbacks.push(() => owner.removeEventListener('toggle', handleOwnerToggle));

        tabs.forEach((tab, index) => {
          const clickHandler = () => activateTab(tab);
          const keyHandler = (event) => {
            let targetIndex = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              targetIndex = (index + 1) % tabs.length;
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              targetIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (event.key === 'Home') {
              targetIndex = 0;
            } else if (event.key === 'End') {
              targetIndex = tabs.length - 1;
            }

            if (targetIndex === null) return;
            event.preventDefault();
            activateTab(tabs[targetIndex], true);
          };

          tab.addEventListener('click', clickHandler);
          tab.addEventListener('keydown', keyHandler);
          aiCleanupCallbacks.push(() => {
            tab.removeEventListener('click', clickHandler);
            tab.removeEventListener('keydown', keyHandler);
          });
        });
      });
      let activeAiTrigger = null;
      let currentAiPrompt = '';
      let currentAiLocale = 'en';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const desktopVisual = window.matchMedia('(min-width: 1200px)');
      // 영상은 원래 1200px 이상에서만 노출되도록 CSS·JS 양쪽이 막고 있었다.
      // CSS 를 모든 폭에서 보이도록 바꿨으므로, 로드/재생 판단도 뷰포트 폭이 아니라
      // 요소가 실제로 화면에 표시되는지로 한다. (desktopVisual 은 폭 변경 감지용으로만 남긴다)
      const visualEl = section.querySelector('.home-story-accordion__visual');
      const isVisualShown = () => !!visualEl && window.getComputedStyle(visualEl).display !== 'none';
      const visualOpeningTime = 0.08;
      let visualFrameCallback = null;

      const clearVisualFrameReady = () => {
        if (visualFrame) visualFrame.removeAttribute('data-frame-ready');
        if (visualVideo && visualFrameCallback !== null && typeof visualVideo.cancelVideoFrameCallback === 'function') {
          visualVideo.cancelVideoFrameCallback(visualFrameCallback);
        }
        visualFrameCallback = null;
      };

      const revealVisualFrame = () => {
        if (!visualFrame || !visualVideo || visualVideo.readyState < 2) return;
        if (!reducedMotion && visualVideo.paused) return;
        if (typeof visualVideo.requestVideoFrameCallback === 'function' && !reducedMotion) {
          if (visualFrameCallback !== null) return;
          visualFrameCallback = visualVideo.requestVideoFrameCallback((now, metadata) => {
            visualFrameCallback = null;
            const mediaTime = typeof metadata.mediaTime === 'number' ? metadata.mediaTime : visualVideo.currentTime;
            if (mediaTime < visualOpeningTime && !visualVideo.paused) {
              revealVisualFrame();
              return;
            }
            visualFrame.setAttribute('data-frame-ready', 'true');
          });
          return;
        }
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => visualFrame.setAttribute('data-frame-ready', 'true'));
        });
      };

      const handleVisualLoadedData = () => {
        if (reducedMotion) revealVisualFrame();
        // 영상 데이터가 준비되기 전에 syncVisualPlayback 이 돌면 readyState < 2 라 pause 로 빠지고,
        // 그 뒤로 다시 재생을 시도하는 지점이 없었다. 로드 완료 시 한 번 더 맞춘다.
        syncVisualPlayback();
      };

      const buildAiPrompt = (locale, compareUrl) => {
        if (locale === 'ko') {
          return `acosmeticstory의 Cores 30종을 처음 접하는 소비자에게 쉽게 설명해 주세요.\n\n공식 사실은 다음 전체 비교 페이지와 연결된 각 제품 페이지를 기준으로 확인해 주세요: ${compareUrl}\n\n먼저 Cores가 무엇인지, Graphic ID·경도·pH·제형 타입·정제수 함량·전성분을 어떻게 읽는지 짧고 쉬운 말로 설명해 주세요. 그 다음 30종 사이에서 소비자가 이해하기 좋은 실제 차이를 비교하고, 선호하는 질감이나 사용 상황을 물어봐 주세요. acosmeticstory가 제공한 사실과 AI의 일반 지식을 활용한 해석을 명확히 구분해 주세요. 답변에는 전체 비교표 링크와 언급한 Core의 제품 페이지 링크를 함께 제공해 주세요.`;
        }

        return `Explain acosmeticstory's 30 Cores in simple language for a consumer seeing them for the first time.\n\nUse the official facts on this comparison page and its linked product pages: ${compareUrl}\n\nFirst explain briefly what Cores are and how to read Graphic ID, hardness, pH, formulation type, water content, and full ingredients. Then compare meaningful differences among the 30 Cores and ask about the user's preferred texture or use case. Clearly distinguish facts supplied by acosmeticstory from interpretations based on your general knowledge. Include the full comparison link and direct product-page links for any Core you mention.`;
      };

      const prepareAiLinks = (trigger) => {
        if (!aiModal || !trigger) return;
        const compareUrl = new URL(trigger.dataset.storyAiCompareUrl || '/pages/intrinsic_list', window.location.origin).href;
        currentAiLocale = trigger.dataset.storyAiLocale || 'en';
        currentAiPrompt = buildAiPrompt(currentAiLocale, compareUrl);
        aiPlatformLinks.forEach((link) => {
          const platform = link.dataset.storyAiPlatform;
          if (platform === 'chatgpt') link.href = `https://chatgpt.com/?q=${encodeURIComponent(currentAiPrompt)}`;
          if (platform === 'perplexity') link.href = `https://www.perplexity.ai/search?q=${encodeURIComponent(currentAiPrompt)}`;
          if (platform === 'gemini') link.href = 'https://gemini.google.com/';
          if (platform === 'claude') link.href = 'https://claude.ai/';
          if (platform === 'grok') link.href = 'https://x.com/i/grok';
        });
        if (aiStatus) aiStatus.textContent = '';
      };

      const closeAiModal = () => {
        if (!aiModal || aiModal.hidden) return;
        aiModal.hidden = true;
        if (activeAiTrigger) activeAiTrigger.focus();
        activeAiTrigger = null;
      };

      const openAiModal = (event) => {
        if (!aiModal) return;
        activeAiTrigger = event.currentTarget;
        prepareAiLinks(activeAiTrigger);
        aiModal.hidden = false;
        const firstLink = aiModal.querySelector('[data-story-ai-platform]');
        if (firstLink) firstLink.focus();
      };

      aiOpenButtons.forEach((button) => {
        button.addEventListener('click', openAiModal);
        aiCleanupCallbacks.push(() => button.removeEventListener('click', openAiModal));
      });

      aiDismissButtons.forEach((button) => {
        button.addEventListener('click', closeAiModal);
        aiCleanupCallbacks.push(() => button.removeEventListener('click', closeAiModal));
      });

      aiPlatformLinks.forEach((link) => {
        const handlePlatformClick = () => {
          const platform = link.dataset.storyAiPlatform;
          if (platform !== 'gemini' && platform !== 'claude' && platform !== 'grok') return;
          if (navigator.clipboard && currentAiPrompt) {
            navigator.clipboard.writeText(currentAiPrompt).then(() => {
              if (aiStatus) aiStatus.textContent = currentAiLocale === 'ko' ? '프롬프트를 복사했습니다. 새 창에 붙여 넣어주세요.' : 'Prompt copied. Paste it into the new window.';
            }).catch(() => {});
          }
        };
        link.addEventListener('click', handlePlatformClick);
        aiCleanupCallbacks.push(() => link.removeEventListener('click', handlePlatformClick));
      });

      const handleAiEscape = (event) => {
        if (event.key === 'Escape' && aiModal && !aiModal.hidden) closeAiModal();
      };
      document.addEventListener('keydown', handleAiEscape);
      aiCleanupCallbacks.push(() => document.removeEventListener('keydown', handleAiEscape));

      const syncVisualPlayback = () => {
        if (!visualVideo) return;
        // PC·모바일 모두 "항목을 선택했을 때"만 재생한다.
        // (상위 아코디언만 펼친 상태에서는 항목 목록만 보이고 영상은 나오지 않는다)
        const shouldPlay = isVisualShown()
          && !reducedMotion
          && section.classList.contains('is-accordion-open')
          && document.visibilityState === 'visible';
        visualVideo.defaultPlaybackRate = 1;
        visualVideo.playbackRate = 1;
        if (shouldPlay && visualVideo.readyState >= 2) {
          visualVideo.play().then(revealVisualFrame).catch(() => {});
        } else {
          visualVideo.pause();
          if (reducedMotion && visualVideo.readyState >= 2) revealVisualFrame();
        }
      };

      const updateVisualSource = () => {
        if (!visualVideo) return;
        const source = visualVideo.dataset.src;
        if (isVisualShown() && source && !visualVideo.getAttribute('src')) {
          clearVisualFrameReady();
          visualVideo.setAttribute('src', source);
          visualVideo.load();
        } else if (!isVisualShown() && visualVideo.getAttribute('src')) {
          visualVideo.pause();
          clearVisualFrameReady();
          visualVideo.removeAttribute('src');
          visualVideo.load();
        }
        syncVisualPlayback();
      };

      // 열린 항목에 지정된 영상이 있으면 대표 영상을 그 항목의 영상으로 교체한다.
      // 지정이 없으면 섹션 대표 영상(defaultVisualSrc)으로 되돌린다.
      const defaultVisualSrc = visualVideo ? visualVideo.dataset.src || '' : '';
      const applyItemVisual = () => {
        if (!visualVideo) return;
        const openItem = items.find((item) => item.open);
        const next = (openItem && openItem.dataset.storyItemVisual) || defaultVisualSrc;
        if (!next || visualVideo.dataset.src === next) return;
        visualVideo.dataset.src = next;
        clearVisualFrameReady();
        visualVideo.pause();
        visualVideo.removeAttribute('src');
        delete visualVideo.dataset.videoLoaded;
        delete visualVideo.dataset.videoReady;
        visualVideo.load();
      };

      // 1200px 미만에서는 영상을 "열린 항목 안"으로 옮겨 붙인다.
      // 원래 위치(stage 끝)에 두면 항목 4개를 모두 지나 목록 맨 아래에 나타나서
      // 어느 항목의 영상인지 알 수 없다. 데스크탑에서는 원래 위치(우측 고정)로 되돌린다.
      const visualStage = section.querySelector('.home-story-accordion__stage');
      const placeVisual = () => {
        if (!visualEl || !visualStage) return;
        const openItem = items.find((item) => item.open);

        if (desktopVisual.matches || !openItem) {
          if (visualEl.parentElement !== visualStage) visualStage.appendChild(visualEl);
          return;
        }

        // 모바일·태블릿에서는 제목 바로 아래(본문 위)에 세운다.
        // appendChild 로 붙이면 details 의 마지막 자식이 되어 본문과 링크를 모두
        // 지난 항목 맨 끝에 나타났다. 본문 패널 앞에 끼워 넣어 순서를 바로잡는다.
        const panel = openItem.querySelector('.home-story-accordion__panel');
        if (!panel) {
          if (visualEl.parentElement !== openItem) openItem.appendChild(visualEl);
          return;
        }
        if (visualEl.parentElement !== openItem || visualEl.nextElementSibling !== panel) {
          openItem.insertBefore(visualEl, panel);
        }
      };

      const updateOpenState = () => {
        const hasOpenItem = items.some((item) => item.open);
        section.classList.toggle('is-accordion-open', hasOpenItem);
        placeVisual();
        applyItemVisual();
        updateVisualSource();
      };

      let parentManuallyToggled = false;
      let stopScrollReveal = () => {};

      const setParentOpen = (isOpen) => {
        if (isOpen) {
          section.classList.add('is-scroll-active');
          stopScrollReveal();
        }
        section.classList.toggle('is-parent-open', isOpen);
        if (parentToggle) parentToggle.setAttribute('aria-expanded', String(isOpen));
        // 상위 아코디언을 여닫는 것만으로도 재생 상태를 다시 맞춘다.
        // (모바일에서는 이 동작이 대표 영상의 노출/숨김과 직결된다)
        updateVisualSource();
      };

      const handleParentToggle = () => {
        parentManuallyToggled = true;
        setParentOpen(!section.classList.contains('is-parent-open'));
      };

      if (parentTrigger) parentTrigger.addEventListener('click', handleParentToggle);

      const stopItemAnimations = (item) => {
        if (item.homeStoryHeightAnimation) {
          item.homeStoryHeightAnimation.onfinish = null;
          item.homeStoryHeightAnimation.cancel();
          item.homeStoryHeightAnimation = undefined;
        }
        if (item.homeStoryPanelAnimation) {
          item.homeStoryPanelAnimation.cancel();
          item.homeStoryPanelAnimation = undefined;
        }
      };

      const animateItem = (item, shouldOpen) => {
        const summary = item.querySelector('.home-story-accordion__summary');
        const panel = item.querySelector('.home-story-accordion__panel');
        if (!summary || !panel) return;

        const startHeight = item.getBoundingClientRect().height;
        stopItemAnimations(item);
        item.style.removeProperty('height');
        item.style.removeProperty('overflow');

        if (shouldOpen) item.open = true;

        item.dataset.accordionTarget = shouldOpen ? 'open' : 'closed';

        if (reducedMotion || typeof item.animate !== 'function') {
          item.open = shouldOpen;
          delete item.dataset.accordionTarget;
          window.requestAnimationFrame(updateOpenState);
          return;
        }

        const endHeight = shouldOpen ? item.getBoundingClientRect().height : summary.getBoundingClientRect().height;
        const duration = shouldOpen ? 560 : 440;
        item.dataset.accordionMotion = shouldOpen ? 'opening' : 'closing';
        item.style.overflow = 'hidden';

        const heightAnimation = item.animate([
          { height: `${startHeight}px` },
          { height: `${endHeight}px` }
        ], {
          duration,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        });

        const panelAnimation = panel.animate(shouldOpen ? [
          { opacity: 0, transform: 'translateY(-10px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ] : [
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-8px)' }
        ], {
          duration: shouldOpen ? 420 : 300,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
          fill: 'both'
        });

        item.homeStoryHeightAnimation = heightAnimation;
        item.homeStoryPanelAnimation = panelAnimation;

        heightAnimation.onfinish = () => {
          if (item.homeStoryHeightAnimation !== heightAnimation) return;
          if (!shouldOpen) item.open = false;
          heightAnimation.onfinish = null;
          heightAnimation.cancel();
          panelAnimation.cancel();
          item.style.removeProperty('height');
          item.style.removeProperty('overflow');
          delete item.dataset.accordionMotion;
          delete item.dataset.accordionTarget;
          item.homeStoryHeightAnimation = undefined;
          item.homeStoryPanelAnimation = undefined;
          window.requestAnimationFrame(updateOpenState);
        };
      };

      items.forEach((item) => {
        const summary = item.querySelector('.home-story-accordion__summary');
        const handleSummaryClick = (event) => {
          event.preventDefault();
          const isOpening = item.dataset.accordionTarget ? item.dataset.accordionTarget !== 'open' : !item.open;

          if (isOpening) {
            items.forEach((otherItem) => {
              if (otherItem !== item && (otherItem.open || otherItem.dataset.accordionTarget === 'open')) {
                animateItem(otherItem, false);
              }
            });
          }

          animateItem(item, isOpening);
        };
        const handleToggle = () => {
          window.requestAnimationFrame(updateOpenState);
        };

        if (summary) summary.addEventListener('click', handleSummaryClick);
        item.addEventListener('toggle', handleToggle);
        item.homeStorySummary = summary;
        item.homeStorySummaryHandler = handleSummaryClick;
        item.homeStoryToggleHandler = handleToggle;
      });

      const isThemeEditor = window.Shopify && window.Shopify.designMode;
      const autoOpenParentOnScroll = section.hasAttribute('data-story-auto-open-parent');
      const shouldRevealOnScroll = (
        (section.classList.contains('home-story-accordion--scroll-reveal') && !reducedMotion) || autoOpenParentOnScroll
      ) && !isThemeEditor && 'IntersectionObserver' in window;

      if (shouldRevealOnScroll && !section.classList.contains('is-scroll-active')) {
        let revealFrame = null;
        let revealStopped = false;
        stopScrollReveal = () => {
          revealStopped = true;
          if (section.homeStoryObserver) {
            section.homeStoryObserver.disconnect();
            delete section.homeStoryObserver;
          }
          window.removeEventListener('scroll', scheduleRevealCheck);
          window.removeEventListener('resize', scheduleRevealCheck);
          if (revealFrame !== null) window.cancelAnimationFrame(revealFrame);
          revealFrame = null;
        };

        const revealSection = () => {
          if (revealStopped) return;
          section.classList.add('is-scroll-active');
          stopScrollReveal();
          if (autoOpenParentOnScroll && !parentManuallyToggled && !section.hasAttribute('data-story-auto-opened')) {
            section.setAttribute('data-story-auto-opened', 'true');
            setParentOpen(true);
          }
        };

        // A jump can skip the observer band entirely; passed sections still reveal once.
        const checkRevealPosition = () => {
          revealFrame = null;
          if (!revealStopped && section.getBoundingClientRect().top <= window.innerHeight * 0.58) {
            revealSection();
          }
        };
        const scheduleRevealCheck = () => {
          if (!revealStopped && revealFrame === null) {
            revealFrame = window.requestAnimationFrame(checkRevealPosition);
          }
        };

        section.classList.add('is-scroll-ready');
        section.homeStoryObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) revealSection();
          });
        }, {
          rootMargin: '-28% 0px -42% 0px',
          threshold: 0
        });
        section.homeStoryObserver.observe(section);
        window.addEventListener('scroll', scheduleRevealCheck, { passive: true });
        window.addEventListener('resize', scheduleRevealCheck);
        checkRevealPosition();
      }

      if (visualVideo) {
        updateVisualSource();
        visualVideo.addEventListener('canplay', syncVisualPlayback);
        visualVideo.addEventListener('loadeddata', handleVisualLoadedData);
        visualVideo.addEventListener('emptied', clearVisualFrameReady);
        desktopVisual.addEventListener('change', updateVisualSource);
        document.addEventListener('visibilitychange', syncVisualPlayback);
      }

      updateOpenState();

      section.homeStoryCleanup = () => {
        stopScrollReveal();
        section.classList.remove('is-scroll-ready');
        delete section.dataset.accordionReady;
        if (visualVideo) {
          visualVideo.removeEventListener('canplay', syncVisualPlayback);
          visualVideo.removeEventListener('loadeddata', handleVisualLoadedData);
          visualVideo.removeEventListener('emptied', clearVisualFrameReady);
          clearVisualFrameReady();
        }
        desktopVisual.removeEventListener('change', updateVisualSource);
        document.removeEventListener('visibilitychange', syncVisualPlayback);
        aiCleanupCallbacks.forEach((cleanup) => cleanup());
        if (collectionHeaderLink) collectionHeaderLink.removeEventListener('click', markCollectionScrollReset);
        if (parentTrigger) parentTrigger.removeEventListener('click', handleParentToggle);
        items.forEach((item) => {
          stopItemAnimations(item);
          if (item.homeStorySummary && item.homeStorySummaryHandler) {
            item.homeStorySummary.removeEventListener('click', item.homeStorySummaryHandler);
          }
          if (item.homeStoryToggleHandler) item.removeEventListener('toggle', item.homeStoryToggleHandler);
        });
      };

      section.dataset.accordionReady = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHomeStoryAccordions());
  } else {
    initializeHomeStoryAccordions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeHomeStoryAccordions(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.home-story-accordion').forEach((section) => {
      if (section.homeStoryObserver) section.homeStoryObserver.disconnect();
      if (section.homeStoryCleanup) section.homeStoryCleanup();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
